import React from 'react';
import {Button} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons';
import './PageLayout.scss';

interface IPageHeaderProps {
    isDisplayBack?: boolean;
    onBackClick?: () => void;
    title: string;
    t: (key: string) => string;
    right?: React.ReactNode;
}

export const PageHeader: React.FC<IPageHeaderProps> = ({onBackClick, title, t, isDisplayBack, right}) => (
    <div className="page-header">
        <div className="d-flex align-items-baseline gap-2">
            {isDisplayBack ? <Button variant="secondary" onClick={onBackClick}>
                <FontAwesomeIcon icon={faAngleLeft} className="ms-2"/>
                <span>{t("Button.back")}</span>
            </Button> : <></>}
            <div className="page-title">{title}</div>
        </div>
        <div>
            {right}
        </div>
    </div>
);
